//弹出信息
var msg = {

  //弹窗
  dialogBoxEl: document.querySelector('.act-dialog-box'),
  //toast
  toastBoxEl: document.querySelector('.act-toast-box'),

  //发送文件弹窗
  sedfileDialogBoxEl: document.querySelector('.act-sendfile-dialog'),
  //发送文件成功toast
  sedfileToastBoxEl: document.querySelector('.act-sendfile-toast-box'),

  //预览文件弹窗
  filePreviewBoxEl: document.querySelector('.act-file-preview-dialog'),
  videoBoxEl: document.querySelector('.dialog-video-box'),
  imgPreviewBoxEl: document.querySelector('.act-img-preview-dialog'),

  //公众号登录，绑定手机号弹层
  gzhBindMobile: document.querySelector('.gzh-bind-mobile'),

  //订阅计划开启弹层
  subscribePlanBoxEl: document.querySelector('.subscribe-plan-dialog'),

  // MA 推送弹层
  maPushBoxEl: document.querySelector('.ma-push-dialog'),

  //推荐标签弹层
  recommendTagBoxEl: document.querySelector('.recommend-tag-dialog'),
  //提交成功弹层
  recommendTagSuccessBoxEl: document.querySelector('.recommend-tag-success-dialog'),

  //推荐文章弹层
  recommendArticleBoxEl: document.querySelector('.recommend-article-dialog'),

  //批量议价弹窗
  bargainEl: document.querySelector('.act-dialog-bargain-box'),

  loginWithCodeBoxEl: document.querySelector('.act-codelogin-dialog'),

  //底部上拉菜单
  upPullList: document.querySelector('.act-dialog-box-select'),

  //产品选择型号
  productTypeSelectEl: document.querySelector('.act-product-select'),

  //秒杀
  miaoShaEl: document.querySelector('#miaoSha'),

  //关联产品弹窗
  relatedEl: document.querySelector('.act-product-related-dialog'),

  //webinar2020 口令弹窗
  meetingsEl: document.querySelector('.webinar-meetings'),

  //复制url弹窗
  copyUrlDialogBoxEl: document.querySelector('.act-copyurl-dialog'),

  //补全信息弹窗
  completeDialogBoxEl: document.querySelector('.act-complete-dialog'),

  //注册订阅最新动态
  registerShowDialogBoxEl: document.querySelector('.register-sub-news-1'),
  registerFormDialogBoxEl: document.querySelector('.register-sub-news-2'),
  registerSuccessShowDialogBoxEl: document.querySelector('.register-sub-news-3'),

  //toast
  toast: function (text, time, width) {
    var _this = this;

    var toastBoxEl = _this.toastBoxEl;
    var toastContentEL = toastBoxEl.querySelector('.toast-content');

    var s = time || 1500;

    toastContentEL.innerText = text ? text : '';

    show();

    setTimeout(function () {
      close();
    }, s);

    function show() {
      toastBoxEl.style.display = 'block';
      if(width){
        toastContentEL.style.width = width
      }
      toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
      toastBoxEl.classList.add('dialog-mask-ani-fade-in');
    }

    function close() {
      toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
      toastBoxEl.classList.add('dialog-mask-ani-fade-out');
      setTimeout(function () {
        toastBoxEl.style.display = 'none';
        if(width){
          toastContentEL.style.width = ''
        }
      }, 230);
    }

  },

  //提示窗没有取消按钮
  alert: function (text, confirm, cancel, title, isAlert) {
    this.dialog(text, confirm, cancel, title, true);
  },

  //提示窗
  dialog: function (text, confirm, cancel, title, isAlert, cancelText, confirmText, className, noClose, noConfirmBtn) {

    var _this = this;
    var dialogBoxEl = _this.dialogBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var contentEL = dialogBoxEl.querySelector('.dialog-content');
    var titleEL = dialogBoxEl.querySelector('.dialog-title');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');


    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }
    if (typeof cancel !== "function") {
      cancel = function () {
      };
    }

    //设置信息
    titleEL.innerText = title ? title : '';
    contentEL.innerHTML = text ? text : '';
    cancelEl.innerText = cancelText ? cancelText : '取消';
    confirmEl.innerText = confirmText ? confirmText : '确定';
    if (isAlert) {
      dialogBoxEl.querySelector('.act-dialog-bt-cancel').classList.add('hide');
    }

    //设置样式
    if (className) {
      dialogEl.classList.add(className);
    }


    //显示
    show();

    confirmEl.addEventListener('click', funcConfirm);

    cancelEl.addEventListener('click', funcCancel);
    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    if (noClose) {
      dialogBoxEl.querySelector('.act-dialog-close').classList.add('hide');
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
    }

    if (noConfirmBtn) {
      dialogBoxEl.querySelector('.act-dialog-bt-confirm').classList.add('hide');
      confirmEl.removeEventListener('click', funcConfirm);
    }

    // 确认
    function funcConfirm() {
      confirm();
      close();
    }


    // 取消
    function funcCancel() {
      cancel();
      close();
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
        //移除样式
        if (className) {
          dialogEl.classList.remove(className);
        }
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', funcConfirm);

      cancelEl.removeEventListener('click', funcCancel);
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  //发送文件弹窗
  dialogSedfile: function (text, email, confirm, cancel, title) {

    var _this = this;
    var dialogBoxEl = _this.sedfileDialogBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var contentEL = dialogBoxEl.querySelector('.dialog-content');
    var titleEL = dialogBoxEl.querySelector('.dialog-title');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var cancelEl = dialogBoxEl.querySelector('.act-dialog-bt-cancel');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
    var inputEl = dialogBoxEl.querySelector('.dialog-input>input');
    var errorEl = dialogBoxEl.querySelector('.dialog-input-error');
    var errorRadioEl = dialogBoxEl.querySelector('.dialog-radio-error');


    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }
    if (typeof cancel !== "function") {
      cancel = function () {
      };
    }

    //移除错误红框
    inputEl.classList.remove('input_error');

    //设置信息
    titleEL.innerText = title ? title : '';
    if (text) {
      contentEL.innerText = text;
    }
    inputEl.value = email;

    //显示
    show();

    confirmEl.addEventListener('click', send);

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    //监听邮箱输入框
    inputEl.addEventListener('keyup', verificationEmail);

    //确认发送
    function send() {
      if (!verificationEmail(inputEl.value)) {
        return;
      }
      // 是否选择了服务订阅
      // if (!verificationRadio()) {
      //   return;
      // }
      success();
      function success() {
        confirm(inputEl.value);
        submitSubscribe();
        close();
      }
    }

    //验证邮箱
    function verificationEmail() {
      var email = inputEl.value;
      if (!email.match(/^\w+[\w\-\.]*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]{2,})+$/)) {
        errorEl.style.display = 'block';
        inputEl.classList.add('input_error');
        return false;
      } else {
        errorEl.style.display = 'none';
        inputEl.classList.remove('input_error');
        return true;
      }
    }

    // 验证是否选择了服务订阅
    function verificationRadio() {
      if (!$(".act-sendfile-dialog .radio-option input[name='plan-item']:checked").val()) {
        errorRadioEl.style.display = 'block';
        return false;
      } else {
        errorRadioEl.style.display = 'none';
        return true;
      }
    }

    // 提交订阅信息
    function submitSubscribe() {
      // 获取选中的值
      var select_text = $(".act-sendfile-dialog .radio-option input[name='plan-item']:checked").val();
      var params = {
        customFormId: 2303171065213146,
        globalUserId: getUserInfo.options.globalUserId,
        instanceId: '',
        items: [
          {
            fieldName: "custom_form_field_1679050571080",
            otherValue: "",
            value: [select_text]
          },
          {fieldName: "linksource", value: window.location.href},
          {fieldName: "utmSource", value: utmObj.utm_source},
          {fieldName: "utmMedium", value: utmObj.utm_medium},
          {fieldName: "utmCampaign", value: utmObj.utm_campaign},
          {fieldName: "utmContent", value: utmObj.utm_content},
          {fieldName: "utmTerm", value: utmObj.utm_term},
          {fieldName: "interests", value: getCookie('interests') || ''},
          {
            fieldName: "modulesources",
            value: window.cateData.userRecodeOption.module || window.cateData.pageModuleName
          }
        ],
        linkId: '',
        referenceUrl: '',
        sess: window.cateData.userInfo.sess,
        url: window.location.href,
        ver: 'v2.0.1',
        openId: common.isWx ? common.getCookie('dell_wx_openid') : '',
        isBind: common.isWx ? true : '',
        weChatId: common.isWx ? window.cateData.weChatId : '',
      };
      postJson(window.cateData.api.actionForm, params, function (data) {
        if (data.body.result === 0) {
          userRecode({
            behaviorType: '下载资料',
            behaviorResult: select_text.indexOf('近期有采购计划') > -1 ? '近期有采购计划' : '近期无采购计划',
          });
        } else {
        }
      });
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
        errorEl.style.display = 'none';
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', send);
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },


  //发送文件成功toast
  toastSedfile: function (text1, text2, time) {
    var _this = this;

    var toastBoxEl = _this.sedfileToastBoxEl;
    var toastContentEL1 = toastBoxEl.querySelector('.text-line-one');
    var toastContentEL2 = toastBoxEl.querySelector('.text-line-two');

    var s = time || 1500;

    if (text1) {
      toastContentEL1.innerText = text1;
      toastContentEL2.innerText = text2 || '';
    }

    show();

    setTimeout(function () {
      close();
    }, s);

    function show() {
      toastBoxEl.style.display = 'block';
      toastBoxEl.classList.remove('dialog-mask-ani-fade-out');
      toastBoxEl.classList.add('dialog-mask-ani-fade-in');
    }

    function close() {
      toastBoxEl.classList.remove('dialog-mask-ani-fade-in');
      toastBoxEl.classList.add('dialog-mask-ani-fade-out');
      setTimeout(function () {
        toastBoxEl.style.display = 'none';
      }, 230);
    }

  },

  //预览文件弹窗
  filePreviewDialog: function (url, title, needLogin, articleId, fileIds, fileName, articleUrl, isJump, hiddenDown, wHeight, previewUrl, leftPageNum, continueFn, verifyType, verifyCookie) {
    var _this = this;
    var dialogBoxEl = _this.filePreviewBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog-filepre-content');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var titleEL = dialogBoxEl.querySelector('.file-action-bar>.title>a>h2');
    var titleLinkEL = dialogBoxEl.querySelector('.file-action-bar>.title>a');
    var closeEl = dialogBoxEl.querySelector('.closeicon');
    var iframeEl = dialogBoxEl.querySelector('.file-preview-box>iframe');
    var collectionEl = dialogBoxEl.querySelector('.collectionicon');
    var likeIconEl = dialogBoxEl.querySelector('.like-icon');
    var downEl = dialogBoxEl.querySelector('.downicon');
    var pageNumEl = dialogBoxEl.querySelector('.file-page-num');
    var bottomBar = dialogBoxEl.querySelector('.file-action-bottom-bar');
    var continueEl = dialogBoxEl.querySelector('.continue-read-btn');

    //动态设置iframe内容高度
    var iframeBoxEl = dialogBoxEl.querySelector('.file-preview-box');
    var h = window.innerHeight * 0.75;
    if (wHeight) {
      iframeBoxEl.style.height = wHeight + 'rem';
    } else {
      iframeBoxEl.style.height = h + 'px';
    }

    //如果articleId 不存在则隐藏点赞按钮
    if (!articleId) {
      likeIconEl.classList.add('hide');
    }

    if (hiddenDown === '1') {
      downEl.classList.add('hide');
    } else {
      downEl.classList.remove('hide');
    }

    if (leftPageNum) {
      pageNumEl.innerText = leftPageNum;
    }
    // 判断是否显示底部的剩余页数 需要登录 未登录 包含预览链接 剩余页数不为0
    if (needLogin && !isLogin() && previewUrl && parseInt(leftPageNum) && verifyType !== 'form') {
      bottomBar.style.display = 'block';
      iframeEl.setAttribute('src', previewUrl);
    }else if (verifyType === 'form' && !$.cookie(verifyCookie)) {
      bottomBar.style.display = 'block';
      iframeEl.setAttribute('src', previewUrl);
    }  else {
      bottomBar.style.display = 'none';
      iframeEl.setAttribute('src', url);
    }
    if (continueFn && previewUrl) {
      bottomBar.style.display = 'block';
      iframeEl.setAttribute('src', previewUrl);
    }
    continueEl.onclick = function () {
      if (continueFn && typeof continueFn == 'function') {
        close();
        continueFn();
      } else if (verifyType === 'form') {
        close();
        smartFormDialog.showDialog();
      } else {
        common.gotoLogin();
      }
    };


    //设置点赞状态
    getCollectionStatus(articleId, collectionEl);

    //添加点赞事件
    likeIconEl.addEventListener('click', addLikeEvent);

    //点赞事件
    function addLikeEvent() {
      addLike(articleId, title, true);
    }

    //设置信息
    if (title === '0') {
      title = '';
    }
    titleEL.innerText = title ? title : '';

    //设置标题跳转链接
    if (isJump === 'n') {
      isJump = false;
    } else {
      isJump = true;
    }

    if (!isJump) {
      titleEL.classList.add('no-link');
      titleLinkEL.setAttribute('href', 'javascript:void(0)');
    } else if (articleUrl) {
      titleLinkEL.setAttribute('href', articleUrl);
    } else if (articleId && articleId !== '0') {
      titleLinkEL.setAttribute('href', solution_host + '/view-' + articleId + '.html');
    } else {
      titleLinkEL.setAttribute('href', 'javascript:void(0)');
    }


    //显示
    show();

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    downEl.addEventListener('click', down);

    // 下载
    function down() {
      filelist.download(fileIds, articleId, title, needLogin, fileName);
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
        //关闭后将url置空
        iframeEl.setAttribute('src', '');
        titleLinkEL.setAttribute('href', 'javascript:void(0)');
      }, 230);

      //移除事件
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      downEl.removeEventListener('click', down);
      likeIconEl.removeEventListener('click', addLikeEvent);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  //预览视频弹窗
  videoDialog: function (url, title, articleId, articleUrl, autoCloseTime, noRecord, endCallback) {
    var _this = this;
    var dialogBoxEl = _this.videoBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog-video-content');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var titleEL = dialogBoxEl.querySelector('.video-action-bar>.title>a>h2');
    var titleLinkEL = dialogBoxEl.querySelector('.video-action-bar>.title>a');
    var closeEl = dialogBoxEl.querySelector('.closeicon');
    // var videoEl = dialogBoxEl.querySelector('.video-box>video');
    var videoBoxEl = dialogBoxEl.querySelector('.video-box');
    var collectionEl = dialogBoxEl.querySelector('.collectionicon');
    var likeIconEl = dialogBoxEl.querySelector('.like-icon');

    var videoEl = document.createElement('video');
    videoEl.setAttribute('autoplay', 'true');
    videoEl.setAttribute('webkit-playsinline', 'true');
    videoEl.setAttribute('playsinline', 'true');
    videoEl.setAttribute('controls', '');
    // videoEl.setAttribute('muted','');
    videoEl.setAttribute('src', url);
    videoBoxEl.append(videoEl);

    //设置点赞状态
    getCollectionStatus(articleId, collectionEl);

    //如果articleId 不存在则隐藏点赞按钮
    if (!articleId) {
      likeIconEl.classList.add('hide');
    }

    //添加点赞事件
    likeIconEl.addEventListener('click', addLikeEvent);

    //点赞事件
    function addLikeEvent() {
      addLike(articleId, title, true);
    }

    var timer = null;
    //自动关闭时间
    if (autoCloseTime) {
      timer = setInterval(function () {
        if (Math.round(videoEl.currentTime) == parseInt(autoCloseTime)) {
          close();
        }
      }, 1000);
    }

    //设置信息
    titleEL.innerText = title ? title : '';
    // videoEl.setAttribute('src', url);

    //设置标题跳转链接
    if (articleUrl) {
      titleLinkEL.setAttribute('href', articleUrl);
    } else if (articleId) {
      titleLinkEL.setAttribute('href', solution_host + '/view-' + articleId + '.html');
    } else {
      titleLinkEL.setAttribute('href', 'javascript:void(0)');
    }


    //显示
    show();

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      videoEl.play();
      if (endCallback && typeof endCallback == 'function') {
        setTimeout(function () {
          $(videoEl).removeAttr('controls');
        }, 200);
        videoEl.addEventListener('ended', function () {
          endCallback();
        });
      }

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      if (timer) {
        clearInterval(timer)
      }
      ;
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
        videoEl.setAttribute('src', '');
        videoEl.remove();
      }, 230);

      videoEl.pause();
      if (endCallback && typeof endCallback == 'function') {
        videoEl.removeEventListener('ended', endCallback);
      }

      if (!noRecord) {
        gioTrackAction.cloudEndPlayVideo(videoEl.currentTime || 0, articleId, title);
      }
      titleLinkEL.setAttribute('href', 'javascript:void(0)');

      likeIconEl.removeEventListener('click', addLikeEvent);
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  bargainDialog: function (productInfo, formConfig, gioClickEvent, gioFooterPhoneClickEvent) {
    // pc端字段映射
    var info = {
      productName: productInfo.productname,
      productImgUrl: productInfo.productImg,
      productDesc: productInfo.productDesc,
      productnum: productInfo.productnum,
      productnumLimit: '9999',
      productSale: productInfo.salePrice,
      productPrice: productInfo.productprice,
      productId: productInfo.productid,
    }
    this.batchDialog(info, formConfig, gioClickEvent, gioFooterPhoneClickEvent)
  },
  /**
   * 议价单
   * @param productInfo 产品信息
   * @param formConfig 表单配置
   * @param gioClickEvent gio点击事件标识符
   */
  batchDialog: function (productInfo, formConfig, gioClickEvent, gioFooterPhoneClickEvent) {
    var _this = this;
    if (gioClickEvent) {
      gio('track', gioClickEvent);
    }

    //如果没有传过来配置，则用批量议价单的配置
    var formConfig = formConfig || window.cateData.batchFrome;

    //设置产品信息
    var productInfoDef = {
      productName: '',
      productImgUrl: '',
      productDesc: '',
      productnum: '1',
      productnumLimit: '9999',
      productSale: '',
      productPrice: '',
      productId: '',
    };
    var info = baseExtend(productInfoDef, productInfo);

    //获取元素
    var dialogBoxEl = formConfig.dialogEl || _this.bargainEl;
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
    //产品信息元素
    var productBoxEl = dialogBoxEl.querySelector('.product-box');
    var productNameEl = dialogBoxEl.querySelector('.product-name');
    var productImgEl = dialogBoxEl.querySelector('.product-img>img');
    var productDescEl = dialogBoxEl.querySelector('.product-dec');
    var productPriceNameEl = dialogBoxEl.querySelector('.item-name-price');
    var productSaleEl = dialogBoxEl.querySelector('.product-sale');
    var productPriceEl = dialogBoxEl.querySelector('.product-price');
    var productTypeEl = dialogBoxEl.querySelector('.product-type');
    var productcontactEl = dialogBoxEl.querySelector('.product-contact-dell');
    var formTitleEl = dialogBoxEl.querySelector('.bargain-title');
    var formDescEl = dialogBoxEl.querySelector('.bargain-dec');
    var formTelValueEl = dialogBoxEl.querySelector('.bargain-tel-value');
    var formKefuEl = dialogBoxEl.querySelector('.bargain-kefu');
    var formBoxEl = dialogBoxEl.querySelector('.bargain-form-box');
    var formIfWishTxt = dialogBoxEl.querySelector('#ifWishTxt');
    var formDescRow = document.querySelector('.desc-row');

    var kefuEl = dialogBoxEl.querySelector('.act-kefu');

    var contentEL = dialogBoxEl.querySelector('.dialog-content');
    if (!productInfo) {
      contentEL.setAttribute('style', 'height: 65vh');
    } else if (productInfo && !productInfo.productId) {
      contentEL.setAttribute('style', 'height: 65vh');
    }

    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    // 自定义提交按钮背景颜色
    if (formConfig.submitBGColor) {
      confirmEl.setAttribute('style', 'background:' + formConfig.submitBGColor);
    } else {
      confirmEl.setAttribute('style', 'background:#f2af29');
    }

    // 设置标题，描述
    formTitleEl.innerText = formConfig.formName;
    if (formConfig.formDesc) {
      if(window.location.href.indexOf('SDI-PowerFlex') > -1){
        formConfig.formDesc = formConfig.formDesc.replace('底价','方案')
      }
      formDescEl.innerHTML = formConfig.formDesc;
    }
    if (formConfig.ifWishText) {
      formIfWishTxt.innerText = formConfig.ifWishText;
    }
    var telValue = formConfig.telValue || '4008846610';
    formTelValueEl.setAttribute('href', 'tel:' + telValue);

    if (formConfig.noDescField) { // 不显示需求描述字段
      formDescRow.style.display = 'none';
    }

    // 是否显示企点客服
    var isShowKefu = formConfig.showKefu || 'y';
    if (isShowKefu === 'n') {
      formKefuEl.style.display = 'none';
    } else {
      formKefuEl.style.display = '';
    }

    //初始化数量选择
    var shopNum = new ProductNumCtr('.dialog-num-cut', '.dialog-num', '.dialog-num-add', info.productnumLimit);
    shopNum.setNum(parseInt(info.productnum));

    if (productInfo && productInfo.productId) {
      //设置信息
      productNameEl.innerText = info.productName;
      productImgEl.setAttribute('src', info.productImgUrl);
      productImgEl.setAttribute('alt', info.productName);
      productDescEl.innerText = info.productDesc;
      if (info.productType && info.productType.length > 0) {
        //
        var productTypeBoxEl = dialogBoxEl.querySelector('.product-item-type');
        var hideIndex = productTypeBoxEl.className.indexOf('hide');
        if (hideIndex != -1) {
          productTypeBoxEl.className = productTypeBoxEl.className.split('hide').join('');
        }
        productTypeEl.innerHTML = info.productType;
      }
      //判断价格
      if (info.productSale && info.productPrice) {
        productPriceNameEl.innerText = '促销价格';
        productSaleEl.innerText = info.productSale;
        productPriceEl.innerText = info.productPrice;
      } else if (info.productSale) {
        productPriceNameEl.innerText = '促销价格';
        productSaleEl.innerText = info.productSale;
        productPriceEl.classList.add('hide');
      } else if (info.productPrice) {
        productPriceNameEl.innerText = '参考价格';
        productSaleEl.innerText = info.productPrice;
        productPriceEl.classList.add('hide');
      } else {
        productPriceNameEl.innerText = '参考价格';
        productSaleEl.classList.add('hide');
        productPriceEl.classList.add('hide');
        productcontactEl.classList.remove('hide');
        productcontactEl.addEventListener('click', function () {
          nav.changeNav(event, 'form', {
            'productname': info.productName,
            'productid': info.productId,
            'productprice': info.productSale ? info.productSale : info.productPrice,
            'productnum': shopNum.getNum(),
            'entrance': info.productName + '/' + info.productId
          });
        });
      }
    } else {
      //  如果没有产品信息，隐藏产品UI
      productBoxEl.setAttribute('style', 'display:none');
      formBoxEl.setAttribute('style', 'margin-top: .4rem');
    }

    //显示弹窗
    show();

    // 行为记录
    userAction.productConsultationClick(info.productName);

    //绑定事件
    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);
    confirmEl.addEventListener('click', send);
    kefuEl.addEventListener('click', openKefu);

    // 初始化表单
    var formName = new HandelValue('dialogName', 'dialogNameV', 'dialogNameVE', 'form-error', '请输入姓名');
    var formMobile = new HandelValue('dialogMobile', 'dialogMobileV', 'dialogMobileVE', 'form-error', '请输入手机', '输入正确的手机号', baseVerif.isMobile);
    var formEmail = new HandelValue('dialogEmail', 'dialogEmailV', 'dialogEmailVE', 'form-error', '请输入邮箱', '输入正确的邮箱', baseVerif.isEmail);
    var formCompName = new HandelValue('dialogCompName', 'dialogCompV', 'dialogCompVE', 'form-error', '请输入公司名称');
    var formIfwish = new HandelRadioVerif('ifWish', 'dialogIfWishVE');
    var formDemandsDesc = document.querySelector('*[data-value="dialogDesc"]');

    // 公司联想值企查查
    new window.selectCompany('.bargain-input-box-company input');

    //设置表单默认值
    formName.set(getUserInfo.options.name || '');
    formMobile.set(getUserInfo.options.mobile || '');
    formEmail.set(getUserInfo.options.email || '');
    formCompName.set(getUserInfo.options.enterpriseName || '');
    formIfwish.setNull();

    formDemandsDesc.value = '';
    formDemandsDesc.addEventListener('input', function () {
      if (formDemandsDesc.value) {
        if (formDemandsDesc.value.length > 500) {
          formDemandsDesc.value = formDemandsDesc.value.substr(0, 500);
        }
      }
    });

    function openKefu() {
      common.productOpenKefu(info.productId);
    }

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      confirmEl.removeEventListener('click', send);
      kefuEl.removeEventListener('click', openKefu);
      if (shopNum) {
        shopNum.destroy();
      }
      shopNum = null;


      //允许后方滚动
      setScroll.removeUnScroll();
    }

    //确认发送
    function send() {
      //进行验证
      formName.change();
      formMobile.change();
      formEmail.change();
      formCompName.change();
      formIfwish.change();
      if (formName.isVerif && formMobile.isVerif && formEmail.isVerif && formCompName.isVerif && formIfwish.isVerif) {
        //进行验证

        var url = window.cateData.api.actionForm;
        var utmObj = {};
        if (common.getCookie('utmObj')) {
          utmObj = JSON.parse(common.getCookie('utmObj'));
        }
        if (isLogin() && !getUserInfo.options.name) {
          var userInfo = [
            {fieldName: "name", value: formName.get()},
            {fieldName: "email", value: formEmail.get()},
            {fieldName: "enterprise_name", value: formCompName.get()},
            {fieldName: "completeSource", value: '意向单完善信息'}
          ]
          memberCommonAPI.updateUserInfo(userInfo);
        }
        var parainfo = {
          customFormId: formConfig.formId,
          globalUserId: getUserInfo.options.globalUserId,
          instanceId: '',
          items: [
            {fieldName: "enterprise_name", value: formCompName.get()},
            {fieldName: "name", value: formName.get()},
            {fieldName: "mobile", value: formMobile.get()},
            {fieldName: "email", value: formEmail.get()},
            {fieldName: "demand", value: formDemandsDesc.value},
            {fieldName: "ifWish", value: formIfwish.get()},
            {fieldName: formConfig.customFilds.productName, value: info.productName},
            {fieldName: formConfig.customFilds.productId, value: info.productId},
            {
              fieldName: formConfig.customFilds.productPrice,
              value: info.productSale ? info.productSale : info.productPrice
            },
            {fieldName: formConfig.customFilds.productNum, value: shopNum.getNum()},
            {fieldName: formConfig.customFilds.linkSourceModule, value: window.cateData.userRecodeOption.module},
            {fieldName: formConfig.customFilds.pagetitle, value: document.title},
            {fieldName: "linksource", value: window.location.href},
            {fieldName: "utmSource", value: utmObj.utm_source},
            {fieldName: "utmMedium", value: utmObj.utm_medium},
            {fieldName: "utmCampaign", value: utmObj.utm_campaign},
            {fieldName: "utmContent", value: utmObj.utm_content},
            {fieldName: "utmTerm", value: utmObj.utm_term},
            {fieldName: "interests", value: getCookie('interests') || ''},
            {
              fieldName: "modulesources",
              value: window.cateData.userRecodeOption.module || window.cateData.pageModuleName
            }
          ],
          linkId: '',
          sess: window.cateData.userInfo.sess,
          referenceUrl: formConfig.referenceUrl || '',
          url: window.location.href,
          ver: "v2.0.1",
          openId: common.isWx ? common.getCookie('dell_wx_openid') : '',
          isBind: common.isWx ? true : '',
          weChatId: common.isWx ? window.cateData.weChatId : '',
        };
        postJson(url, parainfo, function (data) {
          var userR = {behaviorType: formConfig.behaviorType};
          if (data.body.result === 0) {
            setCookie('isSubmit_form_5489','1')
            userR['behaviorResult'] = info.productName;
            if (formConfig.entrance) {
              userR['entrance'] = formConfig.entrance;
            }
            if (!formConfig.noToast) {
              msg.toastSedfile('提交成功！', '请等待戴尔销售专家与您联系');
            }
            userRecode(userR);
            if (formConfig.gioType) {
              gio('track', formConfig.gioType, {
                'ibuyEntrancePageTitle': document.title,
                'ibuyEntrancePageURL': document.URL,
                'productID': info.productId,
                'productname': info.productName,
                'linkSourceurl': window.location.href,
                'company': formCompName.get(),
                'email': formEmail.get(),
                'userName': formName.get(),
                'phoneNumber': formMobile.get(),
                'action_position': formConfig.position || '',
                'ifMatchingcompanyName': window.ifMatchingcompanyName,
              });  //埋点实施方案

              // 企查查关联公司-表单提交成功
              window.selectCompanyGio(formMobile.get());
            }
            if (formConfig.successFn && typeof formConfig.successFn === 'function') {
              var callbackData = {
                'userName': formName.get() || '',
                'phoneNumber': formMobile.get() || '',
                'company': formCompName.get() || '',
                'email': formEmail.get() || '',
                'ifWish': formIfwish.get() || ''
              };
              formConfig.successFn(callbackData);
            }
          } else {
            // 已经提交过表单
            var resContent = data.body.content;
            if (resContent && resContent.repeatFields && resContent.repeatFields.length > 0) {
              if (formConfig.successFn && typeof formConfig.successFn === 'function') {
                var callbackData = {
                  'userName': formName.get() || '',
                  'phoneNumber': formMobile.get() || '',
                  'company': formCompName.get() || '',
                  'email': formEmail.get() || '',
                  'ifWish': formIfwish.get()
                };
                formConfig.successFn(callbackData);
              }
              return;
            }

            userR['behaviorResult'] = "提交失败";
            userRecode(userR);
            if (formConfig.failFn && typeof formConfig.failFn === 'function') {
              formConfig.failFn();
            } else {
              msg.toast('提交失败,请稍后再试');
            }
          }
        });
        close();
      }
    }
  },

  // 公用项目咨询配置
  /**
   *
   * @param gioClickEvent gio点击事件标识符
   * @constructor
   */
  ProjectConsultingDialog: function (gioClickEvent) {
    var _this = this;
    stopEvent();
    _this.batchDialog(null, window.cateData.purchaseIntentionForm, gioClickEvent);
  },

  // 详情页阅读更多表单弹窗
  detailReadMoreDialog: function (gioClickEvent, position) {
    var _this = this;
    var formConfig = {};
    $.extend(true,formConfig,window.cateData.purchaseIntentionForm);
    formConfig.position = position || '';
    formConfig.successFn = function(data) {
      common.setCookie('detailReadMore', true, 1);
      $('.article-read-more').hide();
      $('#content1').show();

      // 增加图片画廊
      imgAddDialog();
    };
    _this.batchDialog(null, formConfig, gioClickEvent);
  },

  //验证码登录弹窗
  dialogLoginWithCode: function (code, confirm, title) {

    var _this = this;
    var dialogBoxEl = _this.loginWithCodeBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var titleEL = dialogBoxEl.querySelector('.dialog-content');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var inputEl = dialogBoxEl.querySelector('.dialog-input>input');
    var errorEl = dialogBoxEl.querySelector('.dialog-input-error');


    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    //移除错误红框
    inputEl.classList.remove('input_error');

    //设置信息
    titleEL.innerText = title ? title : '';

    // inputEl.value = code;

    //显示
    show();

    confirmEl.addEventListener('click', send);

    //监听邮箱输入框
    inputEl.addEventListener('keyup', verificationCode);

    //确认发送
    function send() {
      if (!verificationCode(inputEl.value)) {
        return;
      }
      confirm(inputEl.value);
      close();
    }

    //验证验证码是否正确
    function verificationCode() {
      var inputcode = inputEl.value;
      if (inputcode.toUpperCase() == code.toUpperCase()) {
        errorEl.style.display = 'none';
        inputEl.classList.remove('input_error');
        return true;
      } else {
        errorEl.style.display = 'block';
        inputEl.classList.add('input_error');
        return false;
      }
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
        errorEl.style.display = 'none';
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', send);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  //底部上拉菜单
  dialogList: function (type) {

    var _this = this;
    var dialogBoxEl = _this.upPullList;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var contentEL = dialogBoxEl.querySelector('.dialog-list');

    if (dialogBoxEl.style.display === 'flex' || type === 'close') {
      close();
    } else {
      show();
    }
    //显示

    maskEl.addEventListener('click', close);
    dialogEl.addEventListener('click', close);

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-bottom');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-bottom');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-bottom');
      dialogEl.classList.add('dialog-ani-to-bottom');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);
      maskEl.removeEventListener('click', close);
      dialogEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  dialogPorductSelect: function (productInfo) {
    //设置产品信息
    var productInfoDef = {
      productName: '无内容',
      productImgUrl: '/static/mobile/images/productimgdef.png',
      productDesc: '无内容',
      productTypes: []
    };
    var info = baseExtend(productInfoDef, productInfo);

    //获取元素
    var dialogBoxEl = this.productTypeSelectEl;
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.close-button');

    //产品信息元素
    var productNameEl = dialogBoxEl.querySelector('.product-title');
    var productImgEl = dialogBoxEl.querySelector('.product-pic>img');
    var productDescEl = dialogBoxEl.querySelector('.product-desc');
    var productTypesBox = dialogBoxEl.querySelector('.product-types');

    //设置信息
    productNameEl.innerText = info.productName;
    productImgEl.setAttribute('src', info.productImgUrl);
    productImgEl.setAttribute('alt', info.productName);
    productDescEl.innerText = info.productDesc;
    productTypesBox.innerHTML = '';

    if (info.productTypes) {
      info.productTypes.forEach(function (obj, index) {
        var productType = document.createElement('div');
        productType.className = 'product-type-item';
        productType.innerText = obj.title;
        (function (product) {
          productType.addEventListener('click', function () {
            if (productInfo.typeClickFun) {
              productInfo.typeClickFun();
            }
            window.location.href = product.link;
          });
        })(obj)
        productTypesBox.appendChild(productType);
      })
    }

    //绑定事件
    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    show();
  },

  //秒杀弹窗
  miaoShaDialog: function (msDetailId) {
    var _this = this;
    var dialogBoxEl = _this.miaoShaEl;
    var dialogEl = dialogBoxEl.querySelector('.m-miaosha-content');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.m-ms-close');
    var qiangGouEl = dialogBoxEl.querySelector('.ms-qianggou-btn');
    var codeEl = dialogBoxEl.querySelector('.miaosha-code');
    var errorTipsEl = dialogBoxEl.querySelector('.ms-error-tip');
    var successCon = dialogBoxEl.querySelector('.j-successCon');
    var failCon = dialogBoxEl.querySelector('.j-failCon');
    var codeCon = dialogBoxEl.querySelector('.j-codeCon');

    closeEl.addEventListener('click', close);
    qiangGouEl.addEventListener('click', qiangGou);

    show();

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();

      //gio 埋点
      try {
        gio('track', 'double12miaoshabutton_click', {
          'consultEntrancePage': document.title,
          'consultEntrancePageURL': document.URL
        })
      } catch (e) {
        console.log(e)
      }
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');

      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      qiangGouEl.removeEventListener('click', qiangGou);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    var isSubmitting = false;

    function qiangGou() {
      if (isSubmitting) return;
      if (codeEl.value == '') {
        errorTipsEl.innerText = '请输入兑换码';
        return;
      }
      isSubmitting = true;
      errorTipsEl.innerText = '';
      var url = '/api/miaosha/doaward?award_id=' + msDetailId + '&code=' + codeEl.value;
      getJson(url, '', function (data) {
        isSubmitting = false;
        if (data.errCode == '0') {
          codeCon.style.display = 'none';
          successCon.style.display = 'block';
        } else if (data.errCode == '40101') {
          errorTipsEl.innerText = '您的兑换码输入有误，请重新输入';
        } else if (data.errCode == '40102') {
          errorTipsEl.innerText = '您的抢购码已被兑换，不可重复使用';
        } else {
          codeCon.style.display = 'none';
          failCon.style.display = 'block';
        }
        if (app) {
          app.getInfo();
        }
      });
    }
  },

  //提示窗
  relatedDialog: function (title, highLight, imgUrl, price, confirm, closeFunc) {

    var _this = this;
    var dialogBoxEl = _this.relatedEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var highlinghtEl = dialogBoxEl.querySelector('.highlinght');
    var priceEl = dialogBoxEl.querySelector('.price-content');
    var priceBox = dialogBoxEl.querySelector('.price-box');
    var titleEl = dialogBoxEl.querySelector('.title');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
    var countBoxEl = dialogBoxEl.querySelector('.dialog-close-time');
    var countEl = countBoxEl.querySelector('.count-time');


    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    if (typeof closeFunc !== "function") {
      closeFunc = function () {
      };
    }

    //设置信息
    titleEl.innerHTML = title ? title : '';
    highlinghtEl.innerHTML = highLight ? highLight : '';
    priceEl.innerHTML = price ? '￥' + price + '起' : '联系戴尔';
    dialogBoxEl.querySelector('.prod-img img').src = imgUrl;
    if (!price || price == '0') {
      // 价格为空或0时隐藏促销价
      priceBox.style.display = "none";
    }


    //显示
    show();

    confirmEl.addEventListener('click', funcConfirm);
    maskEl.addEventListener('click', close);
    closeEl.addEventListener('click', close);

    if (getUserInfo.getUserTeam() == 4 || getUserInfo.getUserTeam() == 5) {
      closeEl.style.display = 'none';
      countBoxEl.style.display = 'block';
      var timer = setInterval(function () {
        var curTime = countEl.innerText;
        if (curTime <= 1) {
          close();
          clearInterval(timer);
        } else {
          countEl.innerText = curTime - 1;
        }
      }, 1000);
    }

    // 确认
    function funcConfirm() {
      confirm();
      close();
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', funcConfirm);
      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();

      closeFunc();
    }
  },

  dialogDtf: function (opt) {

    var text = opt.title || '',
      desc = opt.desc || '',
      showCloseBtn = opt.showCloseBtn || true,
      linkText = opt.linkText || '',
      linkUrl = opt.linkUrl || 'javascript:void(0)',
      linkTarget = opt.openNew ? '_blank' : 'self',
      className = opt.className || '',
      icon = opt.icon || '/static/pc/img/campaign/dtf/layer-wait-pic.png',
      closeFunc = opt.closeFunc || '',
      disableClose = opt.disableClose || false,
      linkFunc = opt.linkFunc || false;


    var _this = this;

    //获取元素
    var dialogBoxEl = document.querySelector('.act-dialog-box-dtf');
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
    var linkEl = dialogBoxEl.querySelector('.btn-link');
    var iconEl = dialogBoxEl.querySelector('.dialog-icon img');

    if (!showCloseBtn || disableClose) {
      closeEl.style.display = 'none';
    }

    linkEl.innerHTML = linkText;
    linkEl.setAttribute('href', linkUrl);
    linkEl.setAttribute('target', linkTarget);
    iconEl.setAttribute('src', icon);
    if (linkFunc) {
      linkEl.addEventListener('click', linkFunc);
    }

    if (className) {
      dialogBoxEl.classList.add(className);
    }

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      if (text) {
        var titleEL = dialogEl.querySelector('.text-big');
        titleEL.innerHTML = text;
      }

      var descEL = dialogEl.querySelector('.text-desc');
      if (desc) {
        descEL.style.display = '';
        descEL.innerHTML = desc;
      } else {
        descEL.style.display = 'none';
      }

      if (showCloseBtn) {
        maskEl.addEventListener('click', close);
        closeEl.addEventListener('click', close);
      }

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      if (disableClose) {
        return;
      }
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);
      if (linkFunc) {
        linkEl.removeEventListener('click', linkFunc);
      }

      //允许后方滚动
      setScroll.removeUnScroll();

      if (typeof closeFunc === "function") {
        closeFunc();
      }
    }

    function goHome() {
      window.location.href = window.rootUrl;
    }

    show();

    return {
      'close': close
    }
  },

  /**
   * webinar2020 口令弹窗
   * @param password 口令密码
   */
  webinar2020Dialog: function () {
    var _this = this;
    var dialogBoxEl = _this.meetingsEl;

    var dialogEl = dialogBoxEl.querySelector('.meetings-box');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.webinar-box-close');
    var errorEl = dialogBoxEl.querySelector('.error-tip');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');
      errorEl.innerHTML = '';
      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    //显示
    show();
  },

  //复制url弹窗
  dialogCopyUrl: function (title, url, confirm) {

    var _this = this;
    var dialogBoxEl = _this.copyUrlDialogBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var contentEL = dialogBoxEl.querySelector('.dialog-content');
    var confirmEl = dialogBoxEl.querySelector('.act-dialog-bt-confirm');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');
    var inputEl = dialogBoxEl.querySelector('.dialog-input>input');


    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    //设置信息
    if (title) {
      contentEL.innerText = title;
    }
    inputEl.value = url;

    //显示
    show();

    confirmEl.addEventListener('click', copy);
    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    try {
      new ClipboardJS('.dialog-copyurl-btn');
    } catch (e) {
      console.log('若要使用剪切板功能请引入 /static/plugin/clipboard.min.js')
    }

    //确认发送
    function copy() {
      console.log(inputEl.value);
      confirm(inputEl.value);
      msg.toast('已复制到剪切板');
    }

    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', copy);
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  // 轻注册完善信息后跳转抽奖的弹窗
  lightRegToLucky: function (closeFunc) {
    var gotoLuckTimer = setTimeout(function () {
      lightRegDialog.close();
      window.location.href = window.cateData.linghtRegLuckyLink;
    }, 5000);

    var clearTimer = function () {
      if (typeof closeFunc === 'function') {
        closeFunc();
      }
      clearTimeout(gotoLuckTimer);
    };

    var lightRegDialog = this.dialogDtf({
      title: '会员注册已完成',
      desc: '5s后自动跳转到抽奖页面，<br>关闭弹窗将视为自动放弃抽奖资格',
      linkText: '点击抽奖',
      linkUrl: 'https://smarket.dellemc-solution.com/u/vNyrv2',
      openNew: true,
      icon: 'https://emc-image.dellemc-solution.com/web_images/dialog_to_lucky_title_icon.png',
      className: 'dialog-light-reg-to-lucky',
      closeFunc: clearTimer
    });
  },

  //预览图片弹窗
  imgPreviewDialog: function (url, title) {
    var _this = this;
    var dialogBoxEl = _this.imgPreviewBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog-imgpre-content');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var titleEL = dialogBoxEl.querySelector('.img-action-bar>.title>h2');
    var closeEl = dialogBoxEl.querySelector('.closeicon');
    var imgEl = dialogBoxEl.querySelector('.img-preview-box>img');

    //设置信息
    if (title === '0') {
      title = '';
    }
    titleEL.innerText = title ? title : '';
    imgEl.setAttribute('src', url);

    //显示
    show();

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);


    function show() {

      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  // 补全信息表单
  completeDialog: function (successFunc, title, desc) {
    //阻止冒泡
    stopEvent('click');

    //获取元素
    var dialogBoxEl = this.completeDialogBoxEl;
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var confirmEl = dialogBoxEl.querySelector('.submit-complete-btn');
    var closeEl = dialogBoxEl.querySelector('.act-dialog-close');

    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    //显示弹窗
    show();
    var sourcePage = window.cateData.userRecodeOption.module;
    if(window.cateData.userRecodeOption.category1){
      sourcePage += ',' + window.cateData.userRecodeOption.category1
    }
    gioTrackAction.gio_base('buquanxinxiPopupView',{
      'sourcepage_Name': sourcePage
    });

    //绑定事件
    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);
    confirmEl.addEventListener('click', send);

    // 初始化表单
    var formName = new HandelValue('dialogCompleteName', 'dialogCompleteNameV', 'dialogCompleteNameVE', 'form-error', '请输入姓名');
    // var formMobile = new HandelValue('dialogCompleteMobile', 'dialogCompleteMobileV', 'dialogCompleteMobileVE', 'form-error', '请输入手机号');
    var formEmail = new HandelValue('dialogCompleteEmail', 'dialogCompleteEmailV', 'dialogCompleteEmailVE', 'form-error', '请输入邮箱', '输入正确的邮箱', baseVerif.isEmail);
    var formCompName = new HandelValue('dialogCompleteCompName', 'dialogCompleteCompV', 'dialogCompleteCompVE', 'form-error', '请输入公司名称');

    // 公司联想值企查查
    new window.selectCompany('.complete-input-box-company input');

    //设置表单默认值
    formName.set(getUserInfo.options.name || '');
    // formMobile.set(getUserInfo.options.mobile || '');
    formEmail.set(getUserInfo.options.email || '');
    formCompName.set(getUserInfo.options.enterpriseName || '');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      confirmEl.removeEventListener('click', send);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    //确认发送
    function send() {
      //进行验证
      formName.change();
      // formMobile.change();
      formEmail.change();
      formCompName.change();

      if (formName.isVerif && formEmail.isVerif && formCompName.isVerif) {
        // 进行验证
        var userInfo = [
          {fieldName: "name", value: formName.get()},
          // {fieldMobile: "mobile", value: formMobile.get()},
          {fieldName: "email", value: formEmail.get()},
          {fieldName: "enterprise_name", value: formCompName.get()},
          {fieldName: "completeSource", value: '补全信息弹窗完善信息'}
        ];
        gioTrackAction.gio_base('buquanxinxiPopupSubmit',{
          'userName': formName.get(),
          'phoneNumber': getUserInfo.options.mobile,
          'company': formCompName.get(),
          'email':  formEmail.get(),
          'sourcepage_Name': sourcePage
        });

        var formInfo = {
          'name': formName.get(),
          'email': formEmail.get(),
          'enterprise_name': formCompName.get()
        }

        // 如果是登录状态，更新用户信息
        if(common.isLogin()){
          memberCommonAPI.updateUserInfo(userInfo, function (res) {
            if (res.errCode !== 0) return msg.toast(res.msg);
            if (typeof successFunc === "function") {
              successFunc(formInfo);
            }
          });
        }else{
          successFunc(formInfo);
        }

        close();
      }
    }
  },

  // 资料留资弹窗 在资料中心的文件详情页增加 fileForm=1 参数可现实该弹窗，提交后直接发送下载邮件
  fileFormDialog: function (successFunc, title, desc) {
    //阻止冒泡
    stopEvent('click');

    //获取元素
    var dialogBoxEl =  document.querySelector('.act-file-form-dialog');
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var confirmEl = dialogBoxEl.querySelector('.submit-complete-btn');
    // var closeEl = dialogBoxEl.querySelector('.act-dialog-close');

    if (typeof confirm !== "function") {
      confirm = function () {
      };
    }

    //显示弹窗
    show();
    var sourcePage = window.cateData.userRecodeOption.module;
    if(window.cateData.userRecodeOption.category1){
      sourcePage += ',' + window.cateData.userRecodeOption.category1
    }
    gioTrackAction.gio_base('buquanxinxiPopupView',{
      'sourcepage_Name': sourcePage
    });

    //绑定事件
    // closeEl.addEventListener('click', close);
    // maskEl.addEventListener('click', close);
    confirmEl.addEventListener('click', send);

    // 初始化表单
    var formName = new HandelValue('dialogFileFormName', 'dialogFileFormNameV', 'dialogFileFormNameVE', 'form-error', '请输入姓名');
    // var formMobile = new HandelValue('dialogFileFormMobile', 'dialogFileFormMobileV', 'dialogFileFormMobileVE', 'form-error', '请输入手机号');
    var formEmail = new HandelValue('dialogFileFormEmail', 'dialogFileFormEmailV', 'dialogFileFormEmailVE', 'form-error', '请输入邮箱', '输入正确的邮箱', baseVerif.isEmail);
    var formCompName = new HandelValue('dialogFileFormCompName', 'dialogFileFormCompV', 'dialogFileFormCompVE', 'form-error', '请输入公司名称');

    // 公司联想值企查查
    new window.selectCompany('.complete-input-box-company input');

    //设置表单默认值
    formName.set(getUserInfo.options.name || '');
    // formMobile.set(getUserInfo.options.mobile || '');
    formEmail.set(getUserInfo.options.email || '');
    formCompName.set(getUserInfo.options.enterpriseName || '');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      confirmEl.removeEventListener('click', send);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    //确认发送
    function send() {
      //进行验证
      formName.change();
      // formMobile.change();
      formEmail.change();
      formCompName.change();

      if (formName.isVerif && formEmail.isVerif && formCompName.isVerif) {
        // 进行验证
        var userInfo = [
          {fieldName: "name", value: formName.get()},
          // {fieldMobile: "mobile", value: formMobile.get()},
          {fieldName: "email", value: formEmail.get()},
          {fieldName: "enterprise_name", value: formCompName.get()},
          {fieldName: "completeSource", value: '资料下载完善信息'}
        ];
        gioTrackAction.gio_base('buquanxinxiPopupSubmit',{
          'userName': formName.get(),
          'phoneNumber': getUserInfo.options.mobile,
          'company': formCompName.get(),
          'email':  formEmail.get(),
          'sourcepage_Name': sourcePage
        });

        // 提交到自定义表单
        var params = {
          customFormId: 2304073470411064,
          globalUserId: getUserInfo.options.globalUserId,
          instanceId: '',
          items: [
            {fieldName: "enterprise_name", value: formCompName.get()},
            {fieldName: "name", value: formName.get()},
            // {fieldName: "mobile", value: formMobile.get()},
            {fieldName: "email", value: formEmail.get()},
            {fieldName: "linksource", value: window.location.href},
            {fieldName: "utmSource", value: utmObj.utm_source},
            {fieldName: "utmMedium", value: utmObj.utm_medium},
            {fieldName: "utmCampaign", value: utmObj.utm_campaign},
            {fieldName: "utmContent", value: utmObj.utm_content},
            {fieldName: "utmTerm", value: utmObj.utm_term},
            {fieldName: "interests", value: getCookie('interests') || ''},
            {
              fieldName: "modulesources",
              value: window.cateData.userRecodeOption.module || window.cateData.pageModuleName
            }
          ],
          linkId: '',
          referenceUrl: '',
          sess: window.cateData.userInfo.sess,
          url: window.location.href,
          ver: 'v2.0.1',
          openId: common.isWx ? common.getCookie('dell_wx_openid') : '',
          isBind: common.isWx ? true : '',
          weChatId: common.isWx ? window.cateData.weChatId : '',
        };
        postJson(window.cateData.api.actionForm, params, function (data) {
          if (data.body.result === 0) {
          } else {
            console.log('提交失败');
          }
        });

        var formInfo = {
          'name': formName.get(),
          'email': formEmail.get(),
          'enterprise_name': formCompName.get()
        }

        // 如果是登录状态，更新用户信息
        if(common.isLogin()){
          memberCommonAPI.updateUserInfo(userInfo, function () {
            if (typeof successFunc === "function") {
              successFunc(formInfo);
            }
          });
        }else{
          successFunc(formInfo);
        }

        close();
      }
    }
  },

  loading: function () {
    var _this = this;
    var dialogBoxEl = document.querySelector('.act-loading-dialog');

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');

    function show(info) {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-mask-ani-fade-out');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-mask-ani-fade-in');
      if(info){
        if(info.text){
          dialogBoxEl.querySelector('.loading-text').innerHTML = info.text
        }
      }

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-mask-ani-fade-in');
      dialogEl.classList.add('ddialog-mask-ani-fade-out');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);
      //允许后方滚动
      setScroll.removeUnScroll();
    }
    return {
      show:show,
      close:close
    }
  },

  // 推荐标签弹窗
  recommendTagDialog: function () {
    var _this = this;
    var dialogBoxEl = _this.recommendTagBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var confirmEl = dialogBoxEl.querySelector('.dialog-bt-confirm');
    var closeEl = dialogBoxEl.querySelector('.dialog-bt-cancel');
    var tagBoxEl = dialogBoxEl.querySelector('.dialog-content .scroll-view');

    if (!common.isLogin()) {
      return common.gotoLogin();
    }

    // 初始化表单
    var formMobile = new HandelValue('dialogCompleteMobile', 'dialogCompleteMobileV', 'dialogCompleteMobileVE', 'form-error', '请输入手机号', '请输入正确的手机号', baseVerif.isMobile);
    var formCompanyEmail = new HandelValue('dialogCompleteCompanyEmail', 'dialogCompleteCompanyEmailV', 'dialogCompleteCompanyEmailVE', 'form-error', '请输入企业邮箱', '请输入正确的企业邮箱', baseVerif.isEmail);

    //设置表单默认值
    formMobile.set(getUserInfo.options.mobile || '');
    formCompanyEmail.set(getUserInfo.options.email || '');

    tagsData().then(function () {
      // 显示
      show();
      gioTrackAction.gio_base('popupImp', {'popupType_var': '订阅兴趣弹窗'});
      // 点击标签 切换选中的样式
      $('.recommend-tag-dialog .scroll-view .label').click(function () {
        $(this).toggleClass('label-selected');
      });
    });

    confirmEl.addEventListener('click', funcConfirm);
    maskEl.addEventListener('click', close);
    closeEl.addEventListener('click', close);

    // 标签数据
    function tagsData() {
      var def = $.Deferred();
      var info = {
        OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
        session: common.isLogin() ? common.isLogin().session : '',
      };
      var tagStr = '';

      common.getJson(solution_host + '/api/account/tag', info, function (res) {
        if (common.getSS('recommend_tag_list', true)) {
          // 登录后返回，回填选中的标签
          res.data.forEach(function(item) {
            item.tag.forEach(function (tag) {
              common.getSS('recommend_tag_list', true).forEach(function (ss_tag) {
                if (tag.id == ss_tag) {
                  tag.select = true;
                }
              })
            });
          });
          sessionStorage.removeItem('recommend_tag_list');
        }
        res.data.forEach(function(item) {
          tagStr += '<section class="filter-list__module" id="'+ item.summary +'"><div class="module-list__title">' + item.title +'</div>' + '<ul class="module-list">';
          item.tag.forEach(function (tag) {
            tagStr += '<li class="module-list__item"><div data-id="' + tag.id + '" class="label ' + (tag.select ? 'label-selected' : '') +'">' + tag.title + '</div></li>'
          });
          tagStr += '</ul></section>';
        });
        tagBoxEl.innerHTML = tagStr;
        def.resolve();
      });
      return def;
    }

    // 确认
    function funcConfirm() {
      var tagIdList = $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
        return ($(this).attr('data-id'));
      }).get();
      if (!common.isLogin()) {
        if (tagIdList.length > 0) {
          common.setSS('recommend_tag_list', tagIdList, true);
        }
        return common.gotoLogin();
      }
      if (tagIdList.length === 0) return msg.toast('请选择标签');
      //进行验证
      formMobile.change();
      formCompanyEmail.change();

      if (formMobile.isVerif && formCompanyEmail.isVerif) {
        // 处理埋点数据
        var productsName =  $('#interestProductMA .label-selected').map(function(){
          return ($(this).text());
        }).get().join(',');
        var solutionName =  $('#interestSolutionMA .label-selected').map(function(){
          return ($(this).text());
        }).get().join(',');
        var allTagsName =   $('.recommend-tag-dialog .scroll-view .label-selected').map(function(){
          return ($(this).text());
        }).get().join(',');

        gioTrackAction.gio_base('interestSubmit', {'interestProduct':productsName, 'interestSolution':solutionName, 'subType':''});
        userAction.interestTagSelect(allTagsName);

        common.postJson(solution_host + '/api/account/likeTag', {
          session: common.isLogin() ? common.isLogin().session : '',
          OCSESSID: common.isLogin() ? common.isLogin().OCSESSID: '',
          source: 'wap',
          tag: tagIdList,
          email: formCompanyEmail.value,
          mobile: formMobile.value
        }, function (res) {
          common.setCookie('recommend_tag', true);
        });
        close();
        msg.recommendTagSuccessDialog();
      }
    }

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      confirmEl.removeEventListener('click', funcConfirm);
      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  // 推荐标签成功后弹窗
  recommendTagSuccessDialog: function () {
    var _this = this;
    var dialogBoxEl = _this.recommendTagSuccessBoxEl;
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');

    // 显示
    show();
    maskEl.addEventListener('click', close);
    closeEl.addEventListener('click', close);

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  // 订阅计划开启弹窗
  subscribePlanDialog: function (type) {
    var _this = this;
    var dialogBoxEl = _this.subscribePlanBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var dialogBtn = dialogBoxEl.querySelector('.dialog-btn');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');

    // dialogBoxEl.querySelector('.dialog-img').src = '/static/pc/img/public/dialog/recommend-dialog/recommend-tips-24718' + (type === 'C' ? '-xcx.png' : '.png');

    show();

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);
    dialogBtn.addEventListener('click', type === 'C' ? goCampaign : goCampaign);

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      // 订阅计划已弹出
      common.setCookie('subscribePlanClick_2025618', 1, 365);
      gioTrackAction.gio_base('popupClose', {
        "in_app_message_name": "会员礼遇" + type + "类弹窗"
      });
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
      dialogBtn.removeEventListener('click', type === 'C' ? goXcx : goCampaign);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    function goXcx() {
      close();
      gioTrackAction.gio_base('PopUp_HuiyuanLiyu_Button', {
        "in_app_message_name": "会员礼遇C类弹窗"
      });
      common.gotoUrl('https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fauth%2Flogin&query=utm_source%3Dsolutioncom%26utm_medium%3Dot_md_so%26utm_campaign%3Dmember_ellis-ma-0130%26utm_content%3Dmona-li%26utm_term%3Dma-0130-tanchuang-c%26backUrl%3D%2Fpages%2Fintegral%2Findex');
    }

    function goCampaign() {
      close();
      gioTrackAction.gio_base('PopUp_HuiyuanLiyu_Button', {
        "in_app_message_name": "会员礼遇D类弹窗"
      });
      window.location.href = solution_host + '/miaosha'
    }
  },

  // 企点云MA推送弹窗pi
  maPushDialog: function (img, url, id) {
    return;
    var _this = this;
    var dialogBoxEl = _this.maPushBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');

    if(!img){
      return;
    }

    // 设置一个cookie 弹出后，第二天再弹出
    common.setCookie('maPushDialogCookie', 1, 1);


    _this.show(dialogBoxEl);

    closeEl.addEventListener('click', close);
    maskEl.addEventListener('click', close);

    // 给 ma-push-dialog-img 添加图片
    dialogBoxEl.querySelector('.ma-push-dialog-img').src = img;

    // 给 ma-push-dialog-img 添加链接
    if(url){
      dialogBoxEl.querySelector('.ma-push-dialog-img').onclick = function () {
        gioTrackAction.gio_base('MAsolutionpopover_Click');
        common.gotoUrl(url);
      }
    }

    function close() {
      // 订阅计划已弹出
      common.getJson('/api/qi_cloud/close', {id:id}, function (res) {
        console.log('关闭成功', res)
      });
      gioTrackAction.gio_base('MAsolutionpopover_closedClick');
      _this.close(dialogBoxEl);
      closeEl.removeEventListener('click', close);
      maskEl.removeEventListener('click', close);
    }
  },

  // 文章推荐弹窗
  recommendArticleDialog: function () {
    var _this = this;
    var swiper_new;
    var dialogBoxEl = _this.recommendArticleBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');
    var swiperBoxEl = dialogBoxEl.querySelector('.swiper-wrapper');



    articleData().then(function (res) {
      if(res.length === 0) return;
      // 显示
      show();
      // 初始化swiper
      initSwiper();
    });

    $('.recommend-article-dialog .dialog').click(function(){
      gioTrackAction.gio_base('recommendClick', {'recommendPosition_var':'订阅兴趣弹窗'})
    });

    maskEl.addEventListener('click', close);
    closeEl.addEventListener('click', close);

    // 标签数据
    function articleData() {
      var def = $.Deferred();
      var info = {
        OCSESSID: common.isLogin() ? common.isLogin().OCSESSID : '',
        session: common.isLogin() ? common.isLogin().session : '',
      };
      var swiperStr = '';

      common.getJson(solution_host + '/api/account/tagArticle', info, function (res) {
        console.log(res.data);
        res.data.forEach(function(item) {
          swiperStr += '<div class="swiper-slide">' +
              '<div class="article-item">' +
              '<a href="'+ item.linkUrl +'" target="_blank">' +
              '<div class="cover-img">' +
              '<img src="' + item.coverImageUrl +'" alt="">' +
              '</div>' +
              '<div class="article-title">' + item.title +'</div>' +
              '</a>' +
              '</div></div>';
        });
        swiperBoxEl.innerHTML = swiperStr;
        def.resolve(res.data);
      });
      return def;
    }

    function initSwiper() {
      swiper_new = new Swiper('.recommend-article-dialog .article-swiper', {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        slidesPerGroup: 4,
        spaceBetween: 10,
        observer:true,
        observeParents:true,
        autoHeight: true, //高度随内容变化
        pagination: {
          clickable: true,
          el: '.swiper-recommend-pagination'
        },
      })
    }

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      //移除事件
      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //销毁swiper
      swiper_new.destroy(false);

      //允许后方滚动
      setScroll.removeUnScroll();
    }
  },

  // 公众号登录，绑定手机号
  bindMobileDialog: function (successFunc) {
    stopEvent('click');
    var _this = this;
    var dialogBoxEl = _this.gzhBindMobile;
    var dialogEl = dialogBoxEl.querySelector('.bind-form');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var codeBtnEl = dialogBoxEl.querySelector('.get-phone-code');
    var confirmEl = dialogBoxEl.querySelector('.bind-form-btn');
    var sending = false; // 短信发送中
    var downTime = 60; // 短信倒计时
    var submiting = false; // 点击提交

    // 显示
    show();

    confirmEl.addEventListener('click', submit);
    codeBtnEl.addEventListener('click', send);

    // 初始化表单
    var formMobile = new HandelValue('dialogBindMobile', 'dialogBindMobileV', 'dialogBindMobileVE', 'form-error', '请输入手机号', '输入正确的手机号', baseVerif.isMobile);
    var formCode = new HandelValue('dialogBindMobileCode', 'dialogBindMobileCodeV', 'dialogBindMobileCodeVE', 'form-error', '请输入验证码', '输入正确的验证码', baseVerif.isNum);

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top'
      );
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');

      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');

      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      confirmEl.removeEventListener('click', submit);
      codeBtnEl.removeEventListener('click', send);

      clearFomr();

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    //清空表单对象
    function clearFomr() {
      //指控表单对象
      formMobile = null;
      formCode = null;
    }

    //发送验证码
    function send() {
      formMobile.change();
      if (formMobile.isVerif && !sending) {
        //手机号验证通过
        codeBtnEl.innerHTML = '发送中...';
        codeBtnEl.classList.remove('pointer');
        sending = true;

        memberApi.sendCode(formMobile.get(), '',function (data) {
          if (data.errCode === 0) {
            downTime = 60;
            var timer = setInterval(function () {
              downTime--;
              codeBtnEl.innerHTML = downTime + ' S';
              if (downTime == 0) {
                codeBtnEl.innerHTML = '重新发送';
                codeBtnEl.classList.add('pointer');
                clearInterval(timer);
                timer = null;
                sending = false;
              }
            },1000)
          } else {
            msg.toast(data.msg);
            codeBtnEl.innerHTML = '重新发送';
            codeBtnEl.classList.add('pointer');
            sending = false;
          }
        })
      }
    }

    //绑定手机号
    function submit() {
      //进行验证
      formMobile.change();
      formCode.change();

      if (formMobile.isVerif && formCode.isVerif && !submiting) {
        submiting = true;
        confirmEl.innerHTML = '绑定中...';
        memberApi.loginOrRegister({
          "unique": formMobile.get(),
          "checkCode": formCode.get(),
          "unikey": localStorage.getItem('unikey'),
          "url": window.location.href,
          "globalUserId": getCookie('globalUserId') ? getCookie('globalUserId').replace(/"/g, "") : '',
          "getuserinfo": common.getUrlPara('getuserinfo') || '',
          "moduleSource": common_utmObj.modulesources || '',
          "utm_source": common_utmObj.utm_source || '',
          "utm_medium": common_utmObj.utm_medium || '',
          "utm_campaign": common_utmObj.utm_campaign || '',
          "utm_content": common_utmObj.utm_content || '',
          "utm_term": common_utmObj.utm_term || ''
        }, function (data) {
          submiting = false;
          confirmEl.innerHTML = '绑定手机号';
          if (data.errCode !== 0) return msg.toast(data.msg);
          if (data.errCode === 0) {
            try {
              // gio 埋码
              var giouserinfo = data.data;
              var gioParams = {
                phone_ppl: common.mobileGioEncryption(data.data.mobile),
              }

              gio('people.set',gioParams);
              //cookie中设置一个用户手机
              common.setCookie('dell_userName', data.data.name|| '', 5);
              common.setCookie('dell_userMobile', common.mobileEncryption(data.data.mobile), 5);
              common.setCookie('Activity_MOBILE','MOBILE'+ data.data.mobile +'number', 365);
              gio('track', 'loginSuccess', {'user_Id': data.data.memberId, 'phoneNumber': common.mobileGioEncryption(data.data.mobile),'loginType':'微信扫码'})
              msg.toast('绑定成功');
              common.setCookie('smarketMember_498', JSON.stringify({
                session: data.data.session,
                memberId: data.data.memberId || '',
                email: data.data.email || ''
              }), 5);
              common.setCookie('OCSESSID', data.data.OCSESSID, 5);
            } catch (e) {
              console.log(e);
            }
            setTimeout(function(){
              window.location.reload();
            },500)
          }
          localStorage.removeItem('unikey');
          close();
        });
      }
    }
  },

  // 注册订阅最新动态 判断弹窗显示
  registerNewsDialog: function (position) {
    event.preventDefault();
    if (common.getCookie('formProductsFields')) {
      var formProductsFields = JSON.parse(common.getCookie('formProductsFields'));
      $(".register-sub-news-2 .form-email").val(formProductsFields.email);
      $(".register-sub-news-2 .form-name").val(formProductsFields.name);
    }
    this.registerFormDialog(position);
  },

  // 注册订阅最新动态 未登录
  registerShowDialog: function (position) {
    var _this = this;
    var dialogBoxEl = _this.registerShowDialogBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');
    var dialogBtn = dialogBoxEl.querySelector('.dialog-btn');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');
      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);
      dialogBtn.removeEventListener('click', formShow);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    closeEl.addEventListener('click', close);
    dialogBtn.addEventListener('click', formShow);

    function formShow() {
      close();
      _this.registerFormDialog(position);
    }

    //显示
    show();
    return {
      close: close,
      show: show
    }
  },

  // 注册订阅最新动态 填信息 （position为点击位置）
  registerFormDialog: function (position) {
    var _this = this;
    var dialogBoxEl = _this.registerFormDialogBoxEl;
    var submitting = false;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');
    var dialogBtn = dialogBoxEl.querySelector('.dialog-btn');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');
      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);
      dialogBtn.removeEventListener('click', submit);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    closeEl.addEventListener('click', close);
    dialogBtn.addEventListener('click', submit);

    function submit() {
      if (submitting) return false;
      var emailValue = $(".register-sub-news-2 .form-email").val();
      var nameValue = $(".register-sub-news-2 .form-name").val();
      if (!emailValue) {
        msg.toast('请输入邮箱');
      } else if (!baseVerif.isEmail(emailValue)) {
        msg.toast('请输入正确的邮箱');
      } else if (!nameValue) {
        msg.toast('请输入姓名');
      } else {
        common.setCookie('formProductsFields', JSON.stringify({
          email: emailValue,
          name: nameValue,
        }));
        submitting = true;
        var options = {
          customFormId: "2404091178031485",
          globalUserId: getUserInfo.options.globalUserId,
          instanceId: '',
          items: [{
            fieldName: "name", value: nameValue
          }, {
            fieldName: "email", value: emailValue
          }, {
            fieldName: "custom_form_field_1712650444901", value: position || ""
          }],
          linkId: "47199",
          sess: window.cateData.userInfo.sess,
          referenceUrl: window.location.href,
          url: window.location.href,
          ver: "v2.0.1",
          openId: common.isWx ? common.getCookie('dell_wx_openid') : '',
          isBind: common.isWx ? true : '',
          weChatId: common.isWx ? window.cateData.weChatId : '',
        };
        postJson(window.cateData.api.actionForm, options, function (data) {
          submitting = false;
          if (data.body.result === 0) {
            close();
            _this.registerSuccessShowDialog();
          }
        });
      }

    }

    //显示
    show();
    return {
      close: close,
      show: show
    }
  },

  // 注册订阅最新动态 提交成功
  registerSuccessShowDialog: function () {
    var _this = this;
    var dialogBoxEl = _this.registerSuccessShowDialogBoxEl;

    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');
    var closeEl = dialogBoxEl.querySelector('.dialog-close');

    function show() {
      dialogBoxEl.style.display = 'flex';
      maskEl.classList.remove('dialog-mask-ani-fade-out');
      dialogEl.classList.remove('dialog-ani-to-top');
      maskEl.classList.add('dialog-mask-ani-fade-in');
      dialogEl.classList.add('dialog-ani-from-top');
      //禁止后方滚动
      setScroll.unScroll();
    }

    function close() {
      maskEl.classList.remove('dialog-mask-ani-fade-in');
      maskEl.classList.add('dialog-mask-ani-fade-out');

      dialogEl.classList.remove('dialog-ani-from-top');
      dialogEl.classList.add('dialog-ani-to-top');
      setTimeout(function () {
        dialogBoxEl.style.display = 'none';
      }, 230);

      maskEl.removeEventListener('click', close);
      closeEl.removeEventListener('click', close);

      //允许后方滚动
      setScroll.removeUnScroll();
    }

    closeEl.addEventListener('click', close);

    //显示
    show();
    return {
      close: close,
      show: show
    }
  },

  // 公用显示
  show: function (dialogBoxEl) {
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');

    dialogBoxEl.style.display = 'flex';
    maskEl.classList.remove('dialog-mask-ani-fade-out');
    dialogEl.classList.remove('dialog-ani-to-top');
    maskEl.classList.add('dialog-mask-ani-fade-in');
    dialogEl.classList.add('dialog-ani-from-top');

    //禁止后方滚动
    setScroll.unScroll();
  },

  // 公用关闭
  close: function (dialogBoxEl) {
    var dialogEl = dialogBoxEl.querySelector('.dialog');
    var maskEl = dialogBoxEl.querySelector('.dialog-mask');

    maskEl.classList.remove('dialog-mask-ani-fade-in');
    maskEl.classList.add('dialog-mask-ani-fade-out');

    dialogEl.classList.remove('dialog-ani-from-top');
    dialogEl.classList.add('dialog-ani-to-top');
    setTimeout(function () {
      dialogBoxEl.style.display = 'none';
    }, 230);
    //允许后方滚动
    setScroll.removeUnScroll();
  },

};
